'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuthStore } from '@/stores/authStore';

/**
 * Home Page - Root route handler
 * Redirects to dashboard if authenticated, otherwise to login
 */
export default function HomePage() {
  const router = useRouter();
  const { isAuthenticated, isLoading, checkAuth } = useAuthStore();

  useEffect(() => {
    const init = async () => {
      await checkAuth();
    };
    init();
  }, [checkAuth]);

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        router.replace('/dashboard');
      } else {
        router.replace('/login');
      }
    }
  }, [isAuthenticated, isLoading, router]);

  // Loading state: only Innovanet logo + spinner (brand tokens, light/dark)
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-8 bg-[var(--in-bg)]">
      <img src="/logo-black.png" alt="Innovanet" className="in-logo-light h-12 w-auto max-w-[14rem] object-contain" />
      <img src="/logo-white.png" alt="" className="in-logo-dark h-12 w-auto max-w-[14rem] object-contain" />
      <div className="in-spinner" />
    </div>
  );
}
